import { JSX } from "preact";
import classNames from "classnames";

/**
 * Grid component for creating responsive grid layouts
 * Supports 2, 3, or 4 column layouts
 */
export function Grid(props: { maxGrid?: 2 | 3 | 4; children: JSX.Element }) {
  return (
    <div class={classNames("grid-component", `grid-${props.maxGrid ?? 3}`)}>
      {props.children}
    </div>
  );
}

/**
 * Flex component for creating flexible layouts with centered content
 * Uses flex-center-wrap CSS class for centering and wrapping
 */
export function Flex(props: { children: JSX.Element; className?: string }) {
  return (
    <div class={classNames("flex-center-wrap", props.className)}>
      {props.children}
    </div>
  );
}